export enum QuickLinksBlockTheme {
  Blue = 'blue',
  Gold = 'gold',
}
